import { RequestHandler } from '../../components/utils/utils'
import { IP_RESOLVER_URL } from '../../config'

async function getClientIpWithTimeout(timeoutMs = 200) {
  try {
    const controller = new AbortController()
    const timeoutId = setTimeout(() => controller.abort(), timeoutMs)
    const resp = await fetch(IP_RESOLVER_URL, { signal: controller.signal })
    clearTimeout(timeoutId)
    const json = await resp.json()
    return json.ip
  } catch (e) {
    console.error(e)
    return null
  }
}

const isSessionExpiredMessage = (message) => {
  if (typeof message !== 'string') return false

  const normalizedMessage = message.toLowerCase()
  return /\bjwt expired\b/.test(normalizedMessage) || /\bsession expired\b/.test(normalizedMessage)
}

export default {
  // nextStep({ commit, getters }) {
  //   commit('NEXT_STEP', getters)
  // },
  nextStep({ commit }, stepNumber = null) {
    commit('NEXT_STEP', stepNumber)
  },
  previousStep({ commit }) {
    commit('PREVIOUS_STEP')
  },
  setStep({ commit }, step) {
    commit('SET_STEP', step)
  },
  updateStepState({ commit }, payload) {
    commit('UPDATE_STEP_STATE', payload)
  },

  getNewSession: async ({ commit, dispatch, getters }, payload) => {
    // try {
    const url = `${getters.getTenantKycServiceBaseUrl}/e-kyc/verification/session`
    const headers = {
      'x-kyc-access-token': getters.getCavachAccessToken,
    }

    try {
      const ip = await getClientIpWithTimeout()
      headers['X-Forwarded-For'] = ip
    } catch (e) {
      console.error(e)
    }

    const widgetConfigId = getters.getWidgetConfigId
    const sessionPayload = {
      ...(widgetConfigId ? { widgetConfigId } : {}),
      ...(payload || {}),
    }
    const data = await RequestHandler(url, 'POST', sessionPayload, headers)
    if (data.sessionId) {
      commit('setSession', data.sessionId)
      commit('setSessionExpiresAt', data.expiresAt || null)
      return data
    } else {
      if (isSessionExpiredMessage(data)) {
        commit('SET_STEP', 'SessionExpired')
      }
      throw new Error(data)
    }
    // } catch (e) {
    //   throw new Error(`Error getting new session  ${e}`)
    // }
  },

  fetchAppsWidgetConfig: ({ dispatch, commit, getters }) => {
    return new Promise(async (resolve, reject) => {
      // eslint-disable-line
      try {
        const widgetConfigId = getters.getWidgetConfigId
        const configPath = widgetConfigId ? `/e-kyc/verification/widget-config/${encodeURIComponent(widgetConfigId)}` : '/e-kyc/verification/widget-config/'
        const url = `${getters.getTenantKycServiceBaseUrl}${configPath}`
        const headers = {
          'x-kyc-access-token': getters.getCavachAccessToken,
        }

        try {
          const ip = await getClientIpWithTimeout()
          headers['X-Forwarded-For'] = ip
        } catch (e) {
          console.error(e)
        }
        const data = await RequestHandler(url, 'GET', {}, headers)
        if (data && Object.keys(data) && Object.keys(data).length) {
          if (typeof data === 'string') {
            throw new Error(data)
          }
          commit('setWidgetConfigFromDb', data)
          commit('setWidgetConfigId', data._id || widgetConfigId || '')
          if (data.isVaultEnabled === false && data.isWidgetLogin === false) {
            commit('clearVaultData')
          }
          resolve(data)
        } else {
          throw new Error(data)
        }
      } catch (e) {
        reject(new Error(`Error getting widget config  ${e}`))
      }
    })
  },

  getOnChainConfigByIdAction: ({ dispatch, getters }, payload) => {
    /* eslint-disable */
    return new Promise(async (resolve, reject) => {
      try {
        if (!payload) {
          throw new Error('OnChainConfig id must be provided')
        }
        const url = `${getters.getTenantKycServiceBaseUrl}/e-kyc/verification/onchainkyc-config/${payload}`

        const headers = {
          'x-kyc-access-token': getters.getCavachAccessToken,
        }

        try {
          const ip = await getClientIpWithTimeout()
          headers['X-Forwarded-For'] = ip
        } catch (e) {
          console.error(e)
        }

        const data = await RequestHandler(url, 'GET', {}, headers)
        if (data && Object.keys(data) && Object.keys(data).length) {
          resolve(data)
        } else {
          throw new Error(data)
        }
      } catch (e) {
        reject(new Error(`Error getting onchain config  ${e}`))
      }
    })
  },

  async getClientIp() {
    return getClientIpWithTimeout()
  },
}
